import { convertMinsToHrsMins } from '@vakantiesnl/services/src/util/dateUtils';
import { type Booking, type MicroCopy, type Search } from '@vakantiesnl/types/src';

const stopFlightTime = (flight: Search.Flight | Booking.Flight): string | void => {
	if (!flight.flightSegments || flight.flightSegments.length < 2) {
		return;
	}

	const diff = Math.abs(
		new Date(flight.flightSegments[0].arrivalDateTime).getTime() -
			new Date(flight.flightSegments[1].departureDateTime).getTime(),
	);

	return convertMinsToHrsMins(Math.floor(diff / 1000 / 60));
};

export const getFlightTypeText = (
	flight: Search.Flight | Booking.Flight | Booking.FlightSegment,
	microCopies: MicroCopy,
): string =>
	!('flightSegments' in flight && flight.flightSegments) || flight.flightSegments.length < 2
		? microCopies['directFlight']
		: `1 ${microCopies['stopFlight']} (${stopFlightTime(flight)} ${microCopies['common.hours']})`;
